import React from 'react';
import { useParams } from 'react-router-dom';
import Sidebar from './Sidebar';
import Inbox from './inbox/Inbox';
import Catalog from './catalog/Catalog';
import Dashboard from './dashboard/Dashboard';
import AdForm from './catalog/components/AdForm';
import Students from './students/Students';
import Tutors from './tutors/Tutors';
import TutorSchedule from './tutors/components/TutorSchedule';
import LessonPacks from './lessonpacks/LessonPacks';
import LessonPackDetail from './lessonpacks/LessonPackDetail';
import Payments from './payments/Payments';
import Messaging from './messaging/Messaging';
import FileShare from './fileshare/FileShare';
import Bookings from './bookings/Bookings';
import Recordings from './recordings/Recordings';
import StudentLessonLogs from './students/components/StudentLessonLogs';
import EditStudent from './students/components/EditStudent';
import TutorTests from './tutortests/TutorTests';
import staffApi from './staffApi';


function StudentHome({ activeComponent }) {
  const { id } = useParams();

  const handleUpdateStudent = async (studentId, studentData) => {
    try {
      const response = await staffApi.updateStudent(studentId, studentData);
      if (response.success) {
        return { success: true, message: response.message };
      } else {
        return { success: false, message: response.message || 'Update failed' };
      }
    } catch (err) {
      console.error('Error updating student:', err);
      return { success: false, message: err.response?.data?.message || 'Failed to update student' };
    }
  };

  const renderComponent = () => {
    switch (activeComponent) {
      case 'Inbox':
        return <Inbox />;
      case 'Students':
        return <Students />;
      case 'Tutors':
        return <Tutors />;
      case 'TutorSchedules':
        return <TutorSchedule />;
      case 'Bookings':
        return <Bookings />;
      case 'Recordings':
        return <Recordings />;
      case 'LessonPacks':
        return <LessonPacks />;
      case 'LessonPackDetail':
        return <LessonPackDetail />;
      case 'Payments':
        return <Payments />;
      case 'Catalog':
        return <Catalog/>;
      case 'AdForm':
        return <AdForm/>;
      case 'Messaging':
        return <Messaging/>;
      case 'FileShare':
        return <FileShare/>;
      case 'TutorTests':
        return <TutorTests/>;
      case 'StudentLessonLogs':
        return <StudentLessonLogs />;
      case 'EditStudent':
        return <EditStudent onUpdateStudent={handleUpdateStudent} />;
      default:
        return <Dashboard/>;
    }
  };

  return (
    <Sidebar activeComponent={activeComponent}>
      {renderComponent()}
    </Sidebar>
  );
}

export default StudentHome;